module.exports = __webpack_public_path__ + "img/4.c2698bd9.jpg";